module.exports = __webpack_public_path__ + "static/media/time-back.0a6d288d.svg";